module.exports = __webpack_public_path__ + "img/abranet.1b3f481c.jpg";